import { render } from "./landingOffcanvas.vue?vue&type=template&id=605660e0&scoped=true"
import script from "./landingOffcanvas.vue?vue&type=script&lang=js"
export * from "./landingOffcanvas.vue?vue&type=script&lang=js"

import "./landingOffcanvas.vue?vue&type=style&index=0&id=605660e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605660e0"]])

export default __exports__